import React from "react";
import type { AuthUser } from "./types";

export default function UserBadge({ user }: { user: AuthUser }) {
  return (
    <div className="flex items-center gap-3 rounded-full border border-blue-200 px-4 py-2 bg-white/90">
      <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-sm font-semibold text-blue-700">
        {user.fullName
          .split(" ")
          .map((chunk) => chunk[0])
          .slice(0, 2)
          .join("")
          .toUpperCase()}
      </div>
      <div className="text-xs">
        <p className="font-semibold text-slate-900">{user.fullName}</p>
        <p className="text-slate-500">{user.email}</p>
      </div>
    </div>
  );
}
